import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

import { signIn } from './sign-in';

/**
 * The whole application when nobody is signed in (spec R7.1).
 *
 * One card, one action. Sign-in is Google OAuth against an Internal consent
 * screen, so there is nothing to type here — the domain restriction and the
 * account picker both live on Google's side. A rejected account comes back with
 * the API's message, which the callback surfaces; this screen only starts the
 * journey.
 */
export const SignInScreen = () => (
  <div className="flex min-h-dvh items-center justify-center bg-background px-6">
    <Card className="w-full max-w-sm">
      <CardHeader className="text-center">
        <CardTitle className="text-xl">Atlas</CardTitle>
        <CardDescription>
          Review prototypes and leave comments on them. Sign in with your company
          Google account to continue.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button
          type="button"
          className="w-full"
          onClick={() => {
            signIn();
          }}
        >
          Sign in with Google
        </Button>
      </CardContent>
    </Card>
  </div>
);
